var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 73.7 73.7"}},[_c('circle',{staticStyle:{"fill":"#002f6c"},attrs:{"cx":"36.85","cy":"36.85","r":"36.85"}}),_vm._v(" "),_c('path',{staticStyle:{"fill":"#fff"},attrs:{"d":"M32.76 39.27V54.8H21.95V18.76h10.81v16.43l11.18-16.43h12.03L43.46 36.41 57.08 54.8H43.94L32.76 39.27Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }